module.exports = __webpack_public_path__ + "m4a/invite.m4a?3cf0e28a978f41118c81069303a3e81f";